module.exports = __webpack_public_path__ + "static/img/rrrr_34.841fc29.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/rrrr_34.png
// module id = uthL
// module chunks = 1